import React from "react";
import { ROLE } from "Common/constants/roles";
import ProductionItemsPage from "Common/Components/ProductionItemsPage";

// کالاها در انبار محصولات = قلم‌هایی که item_status آن‌ها in_warehouse است.
// خروج از انبار برای هر قلم مستقل انجام می‌شود؛ سرور شرط مبلغ واریزی را بررسی می‌کند.
const Index = () => (
  <ProductionItemsPage
    pageTitle="کالاها در انبار محصولات"
    itemStatus="in_warehouse"
    advanceLabel="خروج از انبار"
    advanceConfirmText={(item) =>
      `آیا خروج از انبار کالای «${item.goods_full_description || item.goods_description || item.goods_title || item.goods_code || `شماره ${item.line_number ?? item.id}`}» برای مشتری «${item.customer_name || "-"}» را تأیید می‌کنید؟`
    }
    advanceSuccessText="کالا از انبار خارج شد و به فهرست کالاهای خارج‌شده منتقل گردید."
    advanceRoles={[ROLE.WAREHOUSE_KEEPER]}
    canRevert
    revertRoles={[ROLE.WAREHOUSE_KEEPER]}
    emptyText="هیچ کالایی در انبار محصولات نیست"
  />
);

export default Index;
